module.exports = __webpack_public_path__ + "img/img_kakao_alarm.6c9ed40d.png";